import { TagColor } from '@factorialco/deprecated-design-system'
import type {
  SoftwareManagementCustomSoftwareItemFragment,
  SoftwareManagementGetSoftwareSetupQuery,
  SoftwareManagementSoftwareItemFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export type SoftwareContainerType = {
  software?: SoftwareManagementSoftwareItemFragment | null
  customSoftware?: SoftwareManagementCustomSoftwareItemFragment | null
}

export type SoftwareSetup = NonNullable<
  SoftwareManagementGetSoftwareSetupQuery['softwareManagement']['softwareSetup']
>

export const getSoftware = (softwareContainer: SoftwareContainerType): UnionSoftwareType => {
  const software = softwareContainer.software || softwareContainer.customSoftware

  if (!software) {
    throw Error('No software available')
  }

  return software
}

export type UnionSoftwareType =
  | SoftwareManagementSoftwareItemFragment
  | SoftwareManagementCustomSoftwareItemFragment

export const cardPaymentStatusToColor = (status: string) => {
  const colors: Record<string, TagColor> = {
    pending: TagColor.grey,
    reversed: TagColor.radical,
    rejected: TagColor.radical,
    closed: TagColor.viridian,
  }

  return colors[status]
}

export const licenseTypeOptions = () => [
  {
    label: i18n.t(
      'software_management.software_setups.details.fields.license_type.options.per_seat'
    ),
    value: 'per_seat',
  },
  {
    label: i18n.t(
      'software_management.software_setups.details.fields.license_type.options.flat_fee'
    ),
    value: 'flat_fee',
  },
]
